import React from "react";
import { Link } from "react-router-dom";
import { isMobile } from "../../utils/utilityManager";
// import { TruncateLines } from "react-truncate-lines";

function BlogCard(props) {
  return (
    props.blog ? <Link
      to={props.isFromMoreFromGI ? { pathname: props.blog.url_to_open } : `/blog/article-${props.blog.slug}/${props.blog.id}`}
      className=""
      target={props.isFromMoreFromGI ? "_blank" : "_self"}
    >
      <div className="blog-card-container">

        <div className="image-container">
          <img src={props.blog.thumbnail} alt="blog" />
        </div>
        <div className="card-content">
          <div className="card-title">
            {props.blog.title}
          </div>
          {isMobile() && props.hideDescMobile ? (
            ""
          ) : (
            <div className="card-body">
              {props.blog.short_description}

            </div>
          )}
        </div>
      </div>
    </Link> : ""
  );
}

export default BlogCard;
